<template>
  <div class="cpl">
    <div class="cpl-header">
      <h2>送检材料</h2>
    </div>
    <div class="cpl-body">
      <div class="gt-form">
        <div class="gt-form-item is-required">
          <label class="gt-form-item__label">技术说明书</label>
          <div class="gt-form-item__content">
            <div class="gt-input">
              <upload-unit ref="instruction"
                           tip="支持pdf，doc，docx类型文件"
                           url="/virus/sdk/material/upload"
                           :limitType="limitType"
                           v-model="references.instruction"></upload-unit>
            </div>
          </div>
        </div>
        <div class="gt-form-item is-required">
          <label class="gt-form-item__label">委托检验书</label>
          <div class="gt-form-item__content">
            <div class="gt-input">
              <upload-unit ref="checkout"
                           :limitType="limitType"
                           url="/virus/sdk/material/upload"
                           v-model="references.checkout">
                <gt-button class="download-btn"
                           @click="downloadTpl('/virus/common/getTemplate/checkout')"
                           plain><i class="iconfont iconxiazai"></i>下载委托检验书模版</gt-button>
              </upload-unit>
            </div>
          </div>
        </div>
        <div class="gt-form-item is-required">
          <label class="gt-form-item__label">承诺声明</label>
          <div class="gt-form-item__content">
            <div class="gt-input">
              <upload-unit ref="statement"
                           :limitType="limitType"
                           url="/virus/sdk/material/upload"
                           v-model="references.statement">
                <gt-button class="download-btn"
                           @click="downloadTpl('/virus/common/getTemplate/statement')"
                           plain><i class="iconfont iconxiazai"></i>下载承诺申明模版</gt-button>
              </upload-unit>

            </div>
          </div>
        </div>
        <div class="gt-form-item is-required">
          <label class="gt-form-item__label  hide-require">外商代理授权书</label>
          <div class="gt-form-item__content">
            <div class="gt-input">
              <upload-unit :limitType="limitType"
                           tip="支持pdf，doc，docx类型文件"
                           url="/virus/sdk/material/upload"
                           v-model="references.authorization"></upload-unit>
            </div>
          </div>
        </div>
        <div class="gt-form-item is-required">
          <label class="gt-form-item__label">检测服务合同</label>
          <div class="gt-form-item__content">
            <div class="gt-input">
              <upload-unit ref="contract"
                           :limitType="limitType"
                           url="/virus/sdk/material/upload"
                           v-model="references.contract">
                <gt-button class="download-btn"
                           @click="downloadTpl('/virus/common/getTemplate/contract')"
                           plain><i class="iconfont iconxiazai"></i>下载检测服务合同模版</gt-button>
              </upload-unit>
            </div>
          </div>
        </div>
        <!-- <div class="gt-form-item is-required">
          <label class="gt-form-item__label">打款凭证</label>
          <div class="gt-form-item__content">
            <div class="gt-input">
              <upload-unit ref="cert"
                           :limitType="['pdf','png','jpg','jpeg']"
                           :limitNumber="3"
                           :category="2"
                           tip="支持pdf，png，jpg，jpeg类型文件"
                           url="/virus/sdk/material/upload"
                           v-model="references.cert"></upload-unit>
            </div>
          </div>
        </div> -->
        <div class="gt-form-item is-required">
          <label class="gt-form-item__label  hide-require">其他文档</label>
          <div class="gt-form-item__content">
            <div class="gt-input">
              <upload-unit :limitType="['pdf','doc','docx','xls','xlsx']"
                           :limitNumber="10"
                           :category="1"
                           tip="支持pdf，doc，docx，xls，xlsx类型文件"
                           url="/virus/sdk/material/upload"
                           v-model="references.other"></upload-unit>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UploadUnit from './../upload_unit'
export default {
  name: 'Meterial',
  inject: ['sourceData'],
  components: {
    UploadUnit
  },
  data () {
    let references = this.sourceData.materials
    return {
      references,
      checked: '',
      loading: false,
      limitType: ['pdf', 'doc', 'docx']
    }
  },
  // computed: {
  //   userInfo () {
  //     return this.$store.getters.getAccount
  //   }
  // },
  methods: {
    downloadTpl (url) {
      let prefix = '/apiService'
      window.open(prefix + url)
    },
    open () {
      this.$refs.custom.dialogVisible = true
    },
    generateParams () {

    },
    uploadSuccess (file, name) { },
    uploadClear (name) { },
    back () {
      this.$router.push({ name: 'certificationType' })
    },
    validate () {
      let result = []
      let refsKey = Object.keys(this.$refs)
      refsKey.forEach(el => {
        result.push(this.$refs[el].validate())
      })
      return Promise.all(result)
    }
  },
  created () {

  }
}
</script>

<style lang='less' scoped>
.cpl {
  margin-bottom: 20px;
  .cpl-header {
    display: flex;
    height: auto;
    padding-bottom: 16px;
    margin-bottom: 0 !important;
    align-items: center;
    border-bottom: 1px solid #dddddd;
  }
  .cpl-body {
    text-align: left;
    border: none !important;
    .gt-form {
      padding-left: 0;
      .gt-form-item {
        margin-bottom: 6px;
      }
    }
  }
}
.download-btn {
  // margin-left: 20px;
  height: 30px;
  border-color: @base-viColor;
  &:hover,
  &:focus {
    border-color: @base-viColor;
    color: #333333;
  }
  .iconfont {
    margin-right: 6px;
    font-size: 14px;
    // color: @base-viColor;
  }
}
/* form */
.gt-form--inline .gt-form-item__label {
  width: 134px;
  text-align: left;
}
.gt-form-item__content {
  margin-left: 134px;
}
/deep/.gt-checkbox__label {
  font-size: 14px;
}
</style>
